import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ClockIcon } from '@heroicons/react/24/outline';

export default function PayoutDelayBanner({ delayDays = 7, tierName = 'New Account' }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white dark:bg-[#111111] rounded-2xl border border-gray-200 dark:border-[#1A1A1A] overflow-hidden"
    >
      <div className="p-5">
        <div className="flex items-start gap-3.5">
          <div className="w-10 h-10 rounded-xl bg-brand/5 dark:bg-brand/10 flex items-center justify-center flex-shrink-0">
            <ShieldCheckIcon className="w-5 h-5 text-brand/70" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-[13px] font-semibold text-gray-900 dark:text-white">
              Payment Security Review
            </h3>
            <p className="text-xs text-gray-500 dark:text-[#999999] mt-1 leading-relaxed">
              To protect against fraud and disputes, payouts are released after a short security review period.
            </p>
            <div className="mt-3 flex items-center gap-4">
              <div className="flex items-center gap-1.5">
                <ClockIcon className="w-3.5 h-3.5 text-gray-400 dark:text-[#666666]" />
                <span className="text-[11px] font-medium text-gray-500 dark:text-[#999999]">{delayDays}-day clearance</span>
              </div>
              <div className="w-px h-3 bg-gray-200 dark:bg-[#333]" />
              <span className="text-[11px] text-gray-400 dark:text-[#666666]">{tierName}</span>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
